export class RequestProductSize {
    ID?: number;
    RequestID?: number;
    ProductSizeID: number;
}

export default RequestProductSize;